import React from 'react'

export default class ConnectionPod extends React.Component {
  render () {
    return (
      <a href='https://github.com/netbeast/dashboard/issues' target='_blank' className='feedback-pod' title='Give us feedback'>Feedback</a>
    )
  }
}
